module.exports = __webpack_public_path__ + "static/media/veggie animal 4.af5f48fe.jpg";